<div class="pb-6 bg-grey-200 page-padding-y">
  <span
      class="flex items-center justify-between mb-6 break-words page-padding-x"
    >
      <h5 class="text-darkBlue-500"  id="h5-ci-ballot-reference">{{ ciBallotDetailDto?.ballotSummary?.reference }}</h5>
      <app-header-ballot-type ballotType="CIB" id="header-ballot-type"></app-header-ballot-type>
  </span>
  <div class="flex flex-col gap-2 page-padding-x 2xl:flex-row 2xl:gap-0">
    <h5
      class="flex flex-wrap justify-start w-full gap-2 break-words place-items-start"
      id="h5-ci-ballot-question"
    >
      {{ ciBallotDetailDto?.ballotSummary?.question }}
    </h5>

    <div class="float-right">
      <app-vote-legend ballotType="CIB"></app-vote-legend>
    </div>

  </div>
</div>

<div class="flex-1 pt-6 bg-grey-100 page-padding-x page-padding-b">
  <ng-container>
    <app-tab
      #appTab
      [tabs]="visibleTabs"
      id="ballotDetailsTab"
      [initialTabId]="initialTabId"
      (onTabChange)="onTabChange($event)"
    >
    </app-tab>

    <div [class.hidden]="selectedTab !== 'ballotSummary'">
      <ng-container *ngIf="loadingBallotDetail">
        <div class="flex items-center justify-center h-full">
          <app-loading-indicator [size]="32"></app-loading-indicator>
        </div>
      </ng-container>

      <ng-container *ngIf="!loadingBallotDetail && !ciBallotDetailDto">
        <div class="flex items-center justify-center h-full">
          <p>Unable to get ballot details</p>
        </div>
      </ng-container>

      <ng-container *ngIf="!loadingBallotDetail && ciBallotDetailDto">
          <app-ci-summary
            [ciBallotDetailDto]="ciBallotDetailDto"
            (onPlaceVote) = "refreshCIBBallot($event)"
          ></app-ci-summary>
      </ng-container>
    </div>

    <div [class.hidden]="selectedTab !== 'viewVotes'">
      <ng-container *ngIf="!loadingBallotDetail && ciBallotDetailDto">
        <app-cib-votes [cibBallotDetail]="ciBallotDetailDto" (afterSave)="refreshCIBBallot($event)"></app-cib-votes>
      </ng-container>
    </div>

    <div [class.hidden]="selectedTab !== 'internalHistory'">
      <ng-container *ngIf="!loadingBallotDetail && ciBallotDetailDto">
        <app-ballot-internal-history [ballotInternalHistories]="ballotInternalHistories" [isShowingCommentColumn]="false"></app-ballot-internal-history>
      </ng-container>
    </div>
  </ng-container>
</div>
